import { render, staticRenderFns } from "./goDocumentNum.vue?vue&type=template&id=31c4e3d6"
import script from "./goDocumentNum.vue?vue&type=script&lang=js"
export * from "./goDocumentNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports